export const ROLE_SERVICE_ADMIN = 'mybundle-admin';
export const ROLE_PARTNER_ADMIN = 'partner-admin';
export const ROLE_CSR_AGENT = 'csr-agent';
export const ROLE_CSR_VIEW_ONLY = 'csr-view-only';
